// extracted by mini-css-extract-plugin
export default {"wrapper":"QuoteWrapper_wrapper__UMhZ2","image":"QuoteWrapper_image__Rwzbo","content":"QuoteWrapper_content__Lfzg7"};